import { TableColumnItem, TableColumnTypeEnum } from '@ui-lib/components';

export const getUsersTableColumnsConfig = (): TableColumnItem[] => [
  {
    propName: 'fullName',
    captionTranslateKey: 'monitoring.users.columns.fullName',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'email',
    captionTranslateKey: 'monitoring.users.columns.email',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'telegramLogin',
    captionTranslateKey: 'monitoring.users.columns.telegramLogin',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'roleName',
    captionTranslateKey: 'monitoring.users.columns.roleName',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'status',
    captionTranslateKey: 'monitoring.users.columns.status',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'lastLoginDate',
    captionTranslateKey: 'monitoring.users.columns.lastLoginDate',
    type: TableColumnTypeEnum.Text,
    colClass: 'text-align-right',
  },
];
